import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("[ErrorBoundary]", error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex h-screen items-center justify-center bg-[#2a1f0e]">
                    <div className="text-center px-8">
                        <p className="font-display text-2xl text-gold-light tracking-[6px] mb-4">典 藏</p>
                        <p className="text-paper-warm/60 text-sm tracking-[2px] mb-6">页面出现了意外错误</p>
                        <button
                            onClick={() => {
                                this.setState({ hasError: false });
                                window.location.reload();
                            }}
                            className="px-6 py-2 border border-gold/30 rounded text-gold/70 text-sm tracking-[3px] font-serif hover:bg-gold/10 transition-colors"
                        >
                            重新加载
                        </button>
                        <pre className="mt-6 text-[11px] text-ink-faint/40 max-w-md mx-auto text-left overflow-auto">
                            {this.state.error?.message}
                        </pre>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
